module.exports = __webpack_public_path__ + "static/img/2353_phase_function_Paper_PointsHejduk_Prediction.ef6a5c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2353_phase_function_Paper_PointsHejduk_Prediction.png
// module id = sBbU
// module chunks = 0